import { useMutation, useQuery, useQueryClient } from "react-query";
import { api } from "./ESocialJTServiceApi";
const raiz = "/recuperacoes-totalizadores";
export function useCotaRecuperacao(tpInsc, nrInsc, enabled) {
  const inscricao = (nrInsc || "").replace(/\D/g, "");
  const valida =
    Number(tpInsc) === 1
      ? /^(\d{8}|\d{14})$/.test(inscricao)
      : /^\d{11}$/.test(inscricao);
  return useQuery(
    ["cota-recuperacao", tpInsc, inscricao],
    () =>
      api
        .get(raiz + "/cota", { params: { tpInsc, nrInsc: inscricao } })
        .then((r) => r.data),
    {
      enabled: !!enabled && valida,
      retry: false,
      refetchOnWindowFocus: false,
      refetchInterval: 15000
    }
  );
}
export function useRecuperacoes(page) {
  return useQuery(
    [raiz, page],
    () => api.get(raiz, { params: { page } }).then((r) => r.data),
    { keepPreviousData: true, retry: false, refetchOnWindowFocus: false }
  );
}
export function useRecuperacao(id) {
  return useQuery(
    [raiz, id],
    () => api.get(raiz + "/" + id).then((r) => r.data),
    {
      enabled: !!id,
      retry: false,
      refetchInterval: (data) =>
        data?.emAndamento || data?.aguardandoFolha ? 4000 : false
    }
  );
}
export function usePreviaRecuperacao() {
  const client = useQueryClient();
  return useMutation((pedido) => api.post(raiz, pedido).then((r) => r.data), {
    retry: false,
    onSettled: () => client.invalidateQueries("cota-recuperacao"),
    onSuccess: (data) => {
      client.setQueryData([raiz, data.operacao.id], data);
      client.invalidateQueries(raiz);
    }
  });
}
function useAcao(id, acao, payload) {
  const client = useQueryClient();
  return useMutation(
    (dados) =>
      api
        .post(raiz + "/" + id + "/acoes/" + acao, payload(dados))
        .then((r) => r.data),
    {
      retry: false,
      onSettled: () => client.invalidateQueries("cota-recuperacao"),
      onError: () => client.invalidateQueries([raiz, id]),
      onSuccess: (data) => {
        client.setQueryData([raiz, id], data);
        client.invalidateQueries(raiz);
      }
    }
  );
}
export function useExecutarRecuperacao(id) {
  return useAcao(id, "executar", (itens) => ({ itens }));
}
export function useRepetirRecuperacao(id) {
  return useAcao(id, "repetir-falhas", () => ({}));
}
